// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import FormatDate from '../FormatDate/FormatDate';

import './FormatMultipleDate.scss';

interface FormatMultipleDateProps {
    dates: { label: string; value?: number; onClick?: () => void; hide?: boolean }[];
}

const FormatMultipleDate = ({ dates = [] }: FormatMultipleDateProps): ReactElement => (
    <div className="format-multiple-dates">
        {dates.reduce((acc, { label = '', value = 0, onClick, hide = false }): ReactElement[] => {
            return !hide && value
                ? [
                      ...acc,
                      <FormatDate
                          label={label + ' '}
                          date={value}
                          onClick={onClick}
                          key={label}
                          defaultStyle={false}
                      />,
                  ]
                : acc;
        }, [] as ReactElement[])}
    </div>
);

export default FormatMultipleDate;
